// const apiUrl = `https://aba-v2-6k5ud3a4.an.gateway.dev/user/point-history?customerId=24LCP-P04038`;
const apiUrl = `https://aba-v2-6k5ud3a4.an.gateway.dev/user/point-history?customerId=${customerId}`;
  
async function getActivitiesPoint(url) {
  document.getElementById("loading").innerHTML = "Loading...";
  try {
    const response = await fetch(url, {
      method: 'GET',
      mode: "cors",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': 'AIzaSyDHVX-dHdJ25PBQIbmsDpfdbnAQwGsYtUU'
      },
    });
    let data = await response.json();
    
    if (response) {
      hideLoader();
    }
    if (!response.ok) {
      document.querySelector(".rewards-tier__wrapper").style.display = "none"
      document.getElementById("no-activities").innerHTML = "You don’t have any points yet. Start shopping today to earn your first rewards!";
      return false;
    }

    displayActivities(data);
  } catch (error) {
    console.error("Error fetching point history:", error);
  }
}

getActivitiesPoint(apiUrl);

function hideLoader() {
  document.getElementById('loading').style.display = 'none';
  document.getElementById('content-rewards').style.display = 'block';
}

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

function displayActivities(data) {
  const d = new Date(data?.membership_expired);
  const month = months[d.getMonth()];
  const date = d.getDate();
  const year = d.getFullYear();
  
  document.getElementById("reward-balance").innerHTML = data.current_point;
  document.getElementById("reward-expires").innerHTML = `Expires on ${date} ${month} ${year}`;

  if(data.membership_code == 'LocciReguler' || data.membership_code == 'LocciNew') {
    document.getElementById("logo-tier").setAttribute("src", "https://cdn.shopify.com/s/files/1/0753/2544/0294/files/Frame_108_1.svg?v=1767949081");
  } else {
    document.getElementById("logo-tier").setAttribute("src", "https://cdn.shopify.com/s/files/1/0753/2544/0294/files/Frame_109.svg?v=1769587897");
  }
  
  let tab = "";
  
  // Loop to access all rows 
  for (let activity of data.transaction_history) {
    let points = activity.points_amount.toString().split("-")[1] ? activity.points_amount : `+${activity.points_amount}`;
    // let status = activity.title.includes("Earned") ? 'Earned' : 'Spent';
    // let activityDesc = activity.description.includes("Manual adjustments") ? activity.description.split("-")[1] : activity.description;
    let expDate, expMonth, expYear = ""

    const d = new Date(activity?.transaction_time);
    const monthName = months[d.getMonth()];
    const date = d.getDate();
    const year = d.getFullYear();
    
    if(activity.points_amount.toString().split("-")[1] == undefined) {
      const expDatePoint = new Date(d.setFullYear(d.getFullYear() + 1));
      expDate = expDatePoint.getDate();
      expMonth = months[expDatePoint.getMonth()];
      expYear = expDatePoint.getFullYear();
    }
    
    tab += 
      `<li class="rewards-activities__item">
        <div class="reward__description">
          <span class="text--strong">${date} ${monthName} ${year}</span>
          <p style="margin: 5px 0 0;">${activity.name}</p>
          ${activity.points_amount.toString().split("-")[1] ? "" : `<small style="color: #d0021b;">Points expire on ${expDate} ${expMonth} ${expYear}</small>`}
        </div>
        <span class="text--strong text-right">${points}</span>
      </li>`;
  }
  // Setting innerHTML as tab variable
  document.getElementById("rewards-activities").innerHTML = tab;
}